import { SupportTeamData } from '../components/support/supportTypes';
import localSupportData from '../components/support/supportTeamData.json';

import { GOOGLE_API_KEY } from './constants';

export const fetchSupportTeamData = async (
  fileId: string
): Promise<SupportTeamData> => {
  if (!GOOGLE_API_KEY) {
    console.warn('🔑 Google API key not found, using local support team data');
    return localSupportData as SupportTeamData;
  }

  try {
    // Create AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout

    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}`,
      {
        signal: controller.signal,
      }
    );

    clearTimeout(timeoutId); // Clear timeout if request completes

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('👥 Successfully loaded support team data from Google Drive');
    return data as SupportTeamData;
  } catch (error) {
    console.warn(
      '⚠️ Error fetching support team data from Drive, using local data:',
      error
    );
    return localSupportData as SupportTeamData;
  }
};
